import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'translateSafeUrl',
    pure: true
})
export class TranslateSafeUrlPipe implements PipeTransform {

    constructor(
        private translate: TranslateService,
        private sanitizer: DomSanitizer
    ) { }

  transform(key: string | null | undefined): SafeResourceUrl | '' {
    if (!key) return '';

    const translatedUrl = this.translate.instant(key) || '';

    if (!translatedUrl) return '';

    return this.sanitizer.bypassSecurityTrustResourceUrl(translatedUrl);
  }
} 